<script setup lang="ts">
import { ref } from "vue";

const isOpen = ref<boolean>(false);

const toggleMenu = (): void => {
  isOpen.value = !isOpen.value;
};
</script>

<template>
  <nav id="navbar" :class="{ open: isOpen }">
    <NuxtLink to="/" class="brand">
      <span>Roja</span>Tac
    </NuxtLink>

    <div class="links">
      <NuxtLink to="/#services" title="Služby + ceník">Služby + ceník</NuxtLink>
      <NuxtLink to="/projects" title="Projekty">Projekty</NuxtLink>
      <NuxtLink to="/#about-us" title="O nás">O nás</NuxtLink>
      <NuxtLink to="/reviews" title="Recenze">Recenze</NuxtLink>
    </div>

    <div class="buttons">
      <UiButton type="primary" variant="solid" class="btn" href="#contact" trailing-icon="material-symbols:arrow-right-rounded">Kontakt</UiButton>
      <Icon class="menu-icon" name="material-symbols:menu-rounded" @click="toggleMenu" />
    </div>

  </nav>
</template>

<style scoped lang="scss">
#navbar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  gap: 30px;
  transition: max-height 0.4s;
  will-change: max-height;
  position: relative;

  .brand {
    font-size: 27px;
    text-transform: uppercase;
    font-weight: 700;
    color: rgb(var(--title-dark-color));
    text-decoration: none;

    span {
      color: rgb(var(--main-color));
    }
  }

  .links {
    display: flex;
    gap: 30px;
    list-style: none;
    font-weight: 500;
    opacity: 1;
    transition: opacity 0.4s;
    will-change: opacity;
    pointer-events: all;
    width: 100%;
    align-items: center;
    justify-content: flex-end;

    a {
      font-size: 18px;
      color: rgb(var(--text-dark-color));
      text-decoration: none;
      transition: 0.2s;

      &:hover {
        color: rgb(var(--main-color));
      }
    }
  }

  .buttons {
    display: flex;
    align-items: center;
    gap: 20px;

    .btn {
      pointer-events: all;
    }

    .menu-icon {
      display: none;
      color: rgb(var(--mini-title-dark-color));
      cursor: pointer;
      transition: 0.2s;
      font-size: 30px;

      &:hover {
        color: rgb(var(--title-dark-color));
      }
    }
  }
}

@media (max-width: 950px) {
  #navbar {
    flex-wrap: wrap;
    gap: 30px;
    z-index: 1000;
    max-height: 45px;
    justify-content: space-between;

    .links {
      order: 2;
      width: 100%;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      opacity: 0;
      pointer-events: none;
      gap: 20px;

      a {
        width: 100%;
      }
    }

    .buttons .menu-icon {
      display: block;
    }

    &.open {
      max-height: 1000px;

      .links {
        opacity: 1;
        pointer-events: all;
      }
    }
  }
}

@media (max-width: 500px) {
  #navbar {
    .links {
      order: 1;
    }

    .buttons {
      order: 2;
      flex-direction: column;
      align-items: flex-start;

      .btn {
        opacity: 0;
        transition: opacity 0.4s;
        pointer-events: none;
      }

      .menu-icon {
        position: absolute;
        right: 0;
        top: 2.5px;
      }
    }

    &.open {
      .buttons .btn {
        opacity: 1;
        pointer-events: all;
      }
    }
  }
}
</style>